/*
 * @Author: 一叶萩
 * @Date: 2022-03-02 15:13:13
 * @LastEditTime: 2022-03-03 20:58:54
 * @LastEditors: niyingfeng
 * @Description: 数据转化的部分业务方法
 * @FilePath: /cheese/web/src/public/js/convert.js
 */

import _ from 'lodash'
import { isNode } from '../utils/node-env'

/**
 * @description: url search query 转化为对象结构
 * @param {string} searchString
 * @return {object} search Params Object
 */
export function searchStringToParams(searchQuery) {
    if (!_.isString(searchQuery)) {
        return {}
    }
    return _.chain(searchQuery)
    .replace('?', '')
    .split('&')
    .map(_.partial(_.split, _, '=', 2))
    .fromPairs()
    .value()
}

/**
 * @description: 将对象转化为 url search query字符串
 * @param {object} searchParams
 * @return {string} xxx=xxx&xxx=xxx
 */
export function searchParamsToString(searchParams) {
    if(!_.isObject(searchParams)) {
        return ''
    }

    return _.chain(searchParams)
    .toPairs()
    .map(i => `${i[0]}=${encodeURIComponent(i[1])}`)
    .join('&')
    .value()
}

/**
 * @description: 将data对象数据，转化后做为link数据，覆盖合并
 * @param {string} link
 * @param {object} data
 * @return {string} 合并处理后的link
 */
export function linkAppendParams(link, data) {
    if(_.isEmpty(data)) return link

    const linkPart = link.split('?')
    const linkParams = _.assign(searchStringToParams(linkPart[1]), data)

    return `${linkPart[0]}?${searchParamsToString(linkParams)}`
}

const csource = isNode ? '' : searchStringToParams(location?.search).csource

export function appendLinkWithCsource(link) {
    return csource ? linkAppendParams(link, { csource }) : link
}

export function openWindowWithCsource(link) {
    window.open(appendLinkWithCsource(link), '_blank')
}